import * as tslib_1 from "tslib";
import { FieldType } from '@ngx-formly/core';
var FormlyFieldStringInterpolateTextComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FormlyFieldStringInterpolateTextComponent, _super);
    function FormlyFieldStringInterpolateTextComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.classes = 'flex-fill';
        return _this;
    }
    return FormlyFieldStringInterpolateTextComponent;
}(FieldType));
export { FormlyFieldStringInterpolateTextComponent };
